import { useMutation, useQuery, UseQueryOptions, UseQueryResult } from 'react-query'
import { APIEndpoints } from '../constants/api-endpoints'
import { HttpRequest } from '../services/_http'
import { QueryKeys } from './_query_keys'

export const useGetAppVersions = (
    searchOptions?: any,
    options?: UseQueryOptions
): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.APP_VERSIONS, searchOptions]

    return useQuery({
        queryKey,
        queryFn: () =>
            HttpRequest({
                url: APIEndpoints.AppVersion,
                params: searchOptions,
                method,
            }),
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        ...options,
    })
}

export const useStatusAppVersion = (options?: any) => {
    const method = 'PATCH'

    return useMutation(
        ({ id, data }: { id: string | number; data: any }) =>
            HttpRequest({
                url: `${APIEndpoints.BuildVersion}/${id}/status`,
                method,
                data,
            }),
        options
    )
}

export const useUpdateAppVersion = (options?: any) => {
    const method = 'PATCH'

    return useMutation(
        ({ id, data }: { id: string | number; data: any }) =>
            HttpRequest({
                url: `${APIEndpoints.AppVersion}/${id}`,
                method,
                data,
            }),
        options
    )
}

export const useCreateAppVersion = (options?: any) => {
    const method = 'POST'

    return useMutation(
        (data: any) =>
            HttpRequest({
                url: APIEndpoints.AppVersion,
                method,
                data,
            }),
        options
    )
}

export const useDeleteAppVersion = (options?: any) => {
    const method = 'DELETE'

    return useMutation(
        ({ id }: { id: string | number }) =>
            HttpRequest({
                url: `${APIEndpoints.AppVersion}/${id}`,
                method,
            }),
        options
    )
}
